import template from './swag-cms-extensions-form-editor.html.twig';
import './swag-cms-extensions-form-editor.scss';

export default {
    template,
    mixins: [
        'cms-state',
    ],
    computed: {
        groups() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').form.groups;
        },
    },
    methods: {
        onGroupAdd() {
            this.$emit('add-group');
        },
    },
}
